var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.533 19.38-5.43-5.539a7.434 7.434 0 0 0 2.243-5.313C16.346 4.377 12.904 1 8.673 1S1 4.377 1 8.528c0 4.152 3.442 7.529 7.673 7.529a7.727 7.727 0 0 0 4.89-1.733l5.443 5.554a.368.368 0 0 0 .517.01.354.354 0 0 0 .01-.507Z",
    stroke: "#a7a7a7",
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgSearch;